import { VisualAsset, VisualAssetType } from 'core/flow/entities';
import Icon from 'core/svg-sprites/ui/Icon';
import { Image } from '../Image';
import { AnimatedImageStyled } from './styled';

type VisualAssetImageProps = {
  image: VisualAsset;
  width: number;
  height: number;
  className?: string;
};

export const VisualAssetImage = ({ image, width, height, className }: VisualAssetImageProps) => {
  switch (image.type) {
    case VisualAssetType.SPRITE:
      return (
        <Icon
          name={image.name}
          width={width}
          height={height}
          className={className}
          style={{ color: image.color }}
        />
      );
    case VisualAssetType.ANIMATION:
      return (
        <AnimatedImageStyled
          url={image.url}
          loop={image.loop}
          $widthPx={width}
          $heightPx={height}
          className={className}
        />
      );
    default:
      return (
        <Image
          alt={image.alt}
          src={image.src}
          width={width}
          height={height}
          className={className}
        />
      );
  }
};
